// extracted by mini-css-extract-plugin
export default {"addToCartControl":"JZ-z","giftCard":"KZ-z","btnContainer":"LZ-z","cartButton":"MZ-z","disabled":"NZ-z"};